import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "find-srf-consultant-app" }
const _hoisted_2 = {
  key: 0,
  class: "find-srf-consultant-app__status",
  "aria-live": "polite"
}
const _hoisted_3 = { class: "find-srf-consultant-app__loading-text" }
const _hoisted_4 = {
  key: 1,
  class: "find-srf-consultant-app__status error-component",
  role: "alert"
}
const _hoisted_5 = { class: "find-srf-consultant-app__search-row input-text input-text--search" }
const _hoisted_6 = { class: "find-srf-consultant-app__search-field-wrapper" }
const _hoisted_7 = ["aria-controls", "aria-activedescendant", "aria-expanded", "placeholder", "aria-label"]
const _hoisted_8 = {
  key: 0,
  id: "consultant-search-suggestions",
  class: "find-srf-consultant-app__suggestions",
  role: "listbox"
}
const _hoisted_9 = ["id", "aria-selected", "onMousedown"]
const _hoisted_10 = { class: "find-srf-consultant-app__suggestion-type" }
const _hoisted_11 = {
  class: "button find-srf-consultant-app__search-button",
  type: "submit"
}
const _hoisted_12 = { class: "find-srf-consultant-app__filter-options" }
const _hoisted_13 = { class: "find-srf-consultant-app__show-only" }
const _hoisted_14 = { class: "find-srf-consultant-app__show-only-heading" }
const _hoisted_15 = { class: "find-srf-consultant-app__checkbox checkbox" }
const _hoisted_16 = {
  class: "checkbox__label",
  for: "authorized-salary-consultants"
}
const _hoisted_17 = { class: "find-srf-consultant-app__checkbox checkbox" }
const _hoisted_18 = {
  class: "checkbox__label",
  for: "authorized-accounting-consultants"
}
const _hoisted_19 = { class: "find-srf-consultant-app__checkbox checkbox" }
const _hoisted_20 = {
  class: "checkbox__label",
  for: "certified-business-advisors"
}
const _hoisted_21 = { class: "find-srf-consultant-app__checkbox checkbox" }
const _hoisted_22 = {
  class: "checkbox__label",
  for: "authorized-agencies"
}
const _hoisted_23 = ["aria-labelledby"]
const _hoisted_24 = {
  key: 0,
  class: "find-srf-consultant-app__results-header"
}
const _hoisted_25 = {
  id: "consultant-results-heading",
  class: "find-srf-consultant-app__results-heading"
}
const _hoisted_26 = {
  class: "find-srf-consultant-app__results-summary",
  "aria-live": "polite"
}
const _hoisted_27 = { class: "find-srf-consultant-app__mobile-sort dropdown" }
const _hoisted_28 = { for: "consultant-sort" }
const _hoisted_29 = {
  key: 0,
  disabled: "",
  value: ""
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 1,
  class: "find-srf-consultant-app__list"
}
const _hoisted_32 = { class: "find-srf-consultant-app__columns" }
const _hoisted_33 = ["aria-label", "onClick"]
const _hoisted_34 = { class: "find-srf-consultant-app__mobile-column-header-text" }
const _hoisted_35 = { class: "find-srf-consultant-app__rows" }
const _hoisted_36 = ["id", "onClick"]
const _hoisted_37 = { class: "find-srf-consultant-app__stack find-srf-consultant-app__stack--profile" }
const _hoisted_38 = { class: "find-srf-consultant-app__name" }
const _hoisted_39 = { class: "find-srf-consultant-app__mobile-city" }
const _hoisted_40 = ["id"]
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "find-srf-consultant-app__stack find-srf-consultant-app__stack--personal" }
const _hoisted_43 = {
  key: 0,
  class: "find-srf-consultant-app__city"
}
const _hoisted_44 = ["id"]
const _hoisted_45 = { class: "find-srf-consultant-app__stack find-srf-consultant-app__stack--company" }
const _hoisted_46 = { class: "find-srf-consultant-app__company" }
const _hoisted_47 = {
  key: 0,
  class: "find-srf-consultant-app__mobile-authorizations"
}
const _hoisted_48 = ["id"]
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  key: 0,
  class: "find-srf-consultant-app__authorization-summary"
}
const _hoisted_51 = { class: "find-srf-consultant-app__authorization-summary-text" }
const _hoisted_52 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_53 = ["aria-expanded", "aria-controls", "aria-label", "onClick"]
const _hoisted_54 = ["id"]
const _hoisted_55 = {
  key: 2,
  class: "find-srf-consultant-app__no-results"
}
const _hoisted_56 = {
  key: 3,
  class: "find-srf-consultant-app__no-results"
}
const _hoisted_57 = {
  key: 4,
  class: "find-srf-consultant-app__no-results"
}
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = { class: "pagination find-srf-consultant-app__pagination" }
const _hoisted_60 = {
  key: 0,
  class: "pagination__label",
  "aria-disabled": "true"
}
const _hoisted_61 = ["href", "aria-label"]
const _hoisted_62 = ["aria-label", "onClick"]
const _hoisted_63 = {
  key: 1,
  class: "pagination__label",
  "aria-current": "page"
}
const _hoisted_64 = ["href", "aria-label", "onClick"]
const _hoisted_65 = {
  key: 0,
  class: "pagination__label",
  "aria-disabled": "true"
}
const _hoisted_66 = ["href", "aria-label"]

import { computed, nextTick, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue';
  import { debounce } from '@utils/debounce';
  import { useFetch } from '@utils/fetch-service';
  import LoadingSpinner from '@vue-components/LoadingSpinner.vue';
  import ContactReveal from './Components/ContactReveal/ContactReveal.vue';
  import type { IFindSrfConsultant, } from './interfaces/IFindSrfConsultant';
  import type { IFindSrfConsultantPageAppData, } from './interfaces/IFindSrfConsultantPageAppData';
  import type { IFindSrfConsultantSuggestions, } from './interfaces/IFindSrfConsultantSuggestions';

  type SortKey = 'name' | 'city' | 'company' | 'authorization';
  type SortDirection = 'ascending' | 'descending';
  type SearchSuggestion = { type: string; value: string };

  const minimumSearchLength = 3;
  const minimumLoadingDuration = 1200;
  const suggestionDebounceDuration = 300;
  const searchParameter = 'q';
  const typeParameter = 'type';
  const sortParameter = 'sort';
  const pageParameter = 'page';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'FindSrfConsultantApp',
  props: {
    pageId: {},
    locale: {}
  },
  setup(__props: any) {

  const props = __props;

  const appData = ref<IFindSrfConsultantPageAppData | null>(null);
  const suggestionData = ref<IFindSrfConsultantSuggestions | null>(null);
  const isLoading = ref(true);
  const errorMessage = ref('');
  const draftSearch = ref('');
  const committedSearch = ref('');
  const onlyAuthorizedSalaryConsultants = ref(false);
  const onlyAuthorizedAccountingConsultants = ref(false);
  const onlyCertifiedBusinessAdvisors = ref(false);
  const onlyAuthorizedAgencies = ref(false);
  const currentPage = ref(1);
  const isPaginationExpanded = ref(false);
  const expandedConsultantId = ref<string | null>(null);
  const fragmentOnlyConsultantId = ref<string | null>(null);
  const detailAnimations = new WeakMap<HTMLElement, Animation>();
  const sortKey = ref<SortKey | null>(null);
  const sortDirection = ref<SortDirection>('ascending');
  const activeSuggestionIndex = ref(-1);
  const isSuggestionListOpen = ref(false);
  let suggestionCloseTimeout: number | undefined;
  let suggestionAbortController: AbortController | undefined;
  let pageToFocus: number | null = null;
  let latestDataRequestId = 0;
  let latestSuggestionRequestId = 0;
  let isUpdatingSearchState = false;
  const loadSuggestionsDebounced = debounce((...args: unknown[]) => {
    const [search, requestId] = args;

    if (typeof search === 'string'
      && typeof requestId === 'number'
      && requestId === latestSuggestionRequestId) {
      void loadSuggestions(search, requestId);
    }
  }, suggestionDebounceDuration);

  const translations = computed(() => appData.value!.translations);
  const selectedSort = computed({
    get: () => {
      const option = appData.value?.sortOptions.find((item) => item.key === sortKey.value
        && item.direction === sortDirection.value);

      return option ? `${option.key}-${option.direction}` : '';
    },
    set: (value: string) => {
      const option = appData.value?.sortOptions.find((item) => `${item.key}-${item.direction}` === value);

      if (option) {
        sortKey.value = option.key;
        sortDirection.value = option.direction;
        resetResultView();
        updateUrl();
        void loadAppData();
      }
    },
  });
  const loadingLabel = computed(() => appData.value?.translations.loading);

  const columns = computed<{ key: SortKey; label: string }[]>(() => [
    { key: 'name', label: translations.value.name },
    { key: 'city', label: translations.value.city },
    { key: 'company', label: translations.value.company },
    { key: 'authorization', label: translations.value.authorization },
  ]);

  const mobileColumnLabel = computed(() => columns.value.find((column) => column.key === sortKey.value)?.label
    ?? translations.value.name);

  const hasActiveFilters = computed(() => Boolean(
    draftSearch.value
    || committedSearch.value
    || hasSelectedConsultantFilters.value,
  ));
  const committedSearchLength = computed(() => searchWords(committedSearch.value).join('').length);
  const isSearchTooShort = computed(() => committedSearchLength.value > 0
    && committedSearchLength.value < minimumSearchLength);
  const hasAppliedSearchOrFilter = computed(() => Boolean(
    !isSearchTooShort.value
    && (committedSearchLength.value
      || hasSelectedConsultantFilters.value
      || expandedConsultantId.value),
  ));
  const hasSelectedConsultantFilters = computed(() => Boolean(
    onlyAuthorizedSalaryConsultants.value
    || onlyAuthorizedAccountingConsultants.value
    || onlyCertifiedBusinessAdvisors.value
    || onlyAuthorizedAgencies.value,
  ));

  const searchSuggestions = computed<SearchSuggestion[]>(() => {
    const data = suggestionData.value;

    if (!data) {
      return [];
    }

    const suggestions = (values: string[], type: string) => values
      .map((value) => ({ type, value }));

    return [
      ...suggestions(data.companySuggestions, translations.value.company),
      ...suggestions(data.citySuggestions, translations.value.city),
    ];
  });

  const totalPages = computed(() => appData.value?.totalPages ?? 1);
  const pageNumbers = computed(() => {
    const total = totalPages.value;

    if (total <= 5 || isPaginationExpanded.value) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    let start = currentPage.value;
    let end = currentPage.value;

    if (currentPage.value <= 3) {
      start = 2;
      end = 3;
    } else if (currentPage.value >= total - 2) {
      start = total - 2;
      end = total - 1;
    }
    const pages: Array<number | { key: string; firstHiddenPage: number }> = [1];

    if (start > 2) {
      pages.push({ key: 'previous-gap', firstHiddenPage: 2 });
    }

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < total - 1) {
      pages.push({ key: 'next-gap', firstHiddenPage: end + 1 });
    }

    pages.push(total);
    return pages;
  });
  const resultsSummary = computed(() => {
    const total = appData.value?.totalCount ?? 0;
    const size = appData.value?.pageSize ?? 16;
    const first = total ? ((currentPage.value - 1) * size) + 1 : 0;
    const last = Math.min(currentPage.value * size, total);

    return formatTranslation(translations.value.showingResults, first, last, total);
  });

  watch(
    [
      onlyAuthorizedSalaryConsultants,
      onlyAuthorizedAccountingConsultants,
      onlyCertifiedBusinessAdvisors,
      onlyAuthorizedAgencies,
    ],
    () => {
      if (isUpdatingSearchState) {
        return;
      }

      resetResultView();
      updateUrl();
      void loadAppData();
    },
    { flush: 'sync' },
  );

  watch(searchSuggestions, () => {
    activeSuggestionIndex.value = -1;
  });

  onBeforeMount(async () => {
    applySearchStateFromUrl();
    const loadingStartedAt = performance.now();

    await loadAppData();
    const remainingLoadingTime = minimumLoadingDuration - (performance.now() - loadingStartedAt);

    if (remainingLoadingTime > 0) {
      await new Promise<void>((resolve) => {
        window.setTimeout(resolve, remainingLoadingTime);
      });
    }

    isLoading.value = false;
  });

  window.addEventListener('popstate', handlePopState);
  window.addEventListener('hashchange', handleHashChange);

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', handlePopState);
    window.removeEventListener('hashchange', handleHashChange);
    window.clearTimeout(suggestionCloseTimeout);
    cancelSuggestionSearch();
  });

  function applySearch() {
    const search = draftSearch.value.trim();

    draftSearch.value = search;
    committedSearch.value = search;
    cancelSuggestionSearch();
    closeSuggestionsImmediately();
    resetResultView();
    updateUrl();
    void loadAppData();
  }

  function applySearchFromInput(event: Event) {
    draftSearch.value = (event.target as HTMLInputElement).value;
    applySearch();
  }

  function moveSuggestion(direction: number) {
    if (!searchSuggestions.value.length) {
      return;
    }

    isSuggestionListOpen.value = true;
    activeSuggestionIndex.value = (activeSuggestionIndex.value + direction + searchSuggestions.value.length)
      % searchSuggestions.value.length;
  }

  function handleSuggestionInput() {
    window.clearTimeout(suggestionCloseTimeout);
    isSuggestionListOpen.value = true;
    scheduleSuggestionSearch();
  }

  function selectActiveSuggestion(event: KeyboardEvent) {
    const suggestion = searchSuggestions.value[activeSuggestionIndex.value];

    if (!suggestion || !isSuggestionListOpen.value) {
      return;
    }

    event.preventDefault();
    selectSuggestion(suggestion.value);
  }

  function selectSuggestion(value: string) {
    const search = replaceCurrentSearchWord(draftSearch.value, value);

    draftSearch.value = search;
    committedSearch.value = search;
    cancelSuggestionSearch();
    closeSuggestionsImmediately();
    resetResultView();
    updateUrl();
    void loadAppData();
  }

  function closeSuggestions() {
    suggestionCloseTimeout = window.setTimeout(closeSuggestionsImmediately, 150);
  }

  function closeSuggestionsImmediately() {
    window.clearTimeout(suggestionCloseTimeout);
    isSuggestionListOpen.value = false;
    activeSuggestionIndex.value = -1;
  }

  function scheduleSuggestionSearch() {
    suggestionAbortController?.abort();
    suggestionAbortController = undefined;
    suggestionData.value = null;
    const requestId = ++latestSuggestionRequestId;

    if (currentSearchWord(draftSearch.value).length < minimumSearchLength) {
      return;
    }

    const search = draftSearch.value;
    loadSuggestionsDebounced(search, requestId);
  }

  async function loadSuggestions(search: string, requestId: number) {
    const { get } = useFetch('/findsrfconsultantapp/suggestions');
    const abortController = new AbortController();

    // If a new request is made before the previous one completes, abort the previous request
    suggestionAbortController = abortController;

    try {
      const data = await get<IFindSrfConsultantSuggestions>({
        pageId: props.pageId,
        locale: props.locale,
        q: search,
      }, { signal: abortController.signal });

      if (requestId === latestSuggestionRequestId) {
        suggestionData.value = data;
      }
    } catch (error) {
      if (requestId === latestSuggestionRequestId && !(error instanceof DOMException && error.name === 'AbortError')) {
        suggestionData.value = null;
      }
    } finally {
      if (requestId === latestSuggestionRequestId) {
        suggestionAbortController = undefined;
      }
    }
  }

  function cancelSuggestionSearch() {
    suggestionAbortController?.abort();
    suggestionAbortController = undefined;
    suggestionData.value = null;
    latestSuggestionRequestId += 1;
  }

  function clearFilters() {
    isUpdatingSearchState = true;
    draftSearch.value = '';
    committedSearch.value = '';
    onlyAuthorizedSalaryConsultants.value = false;
    onlyAuthorizedAccountingConsultants.value = false;
    onlyCertifiedBusinessAdvisors.value = false;
    onlyAuthorizedAgencies.value = false;
    sortKey.value = null;
    sortDirection.value = 'ascending';
    fragmentOnlyConsultantId.value = null;
    cancelSuggestionSearch();
    closeSuggestionsImmediately();
    resetResultView();
    isUpdatingSearchState = false;

    const url = new URL(window.location.href);
    url.search = '';
    url.hash = '';
    window.history.replaceState({}, '', url.toString());
    void loadAppData();
  }

  function resetResultView() {
    currentPage.value = 1;
    isPaginationExpanded.value = false;
    expandedConsultantId.value = null;
  }

  async function loadAppData() {
    const requestId = ++latestDataRequestId;
    const { get } = useFetch('/findsrfconsultantapp/data');

    errorMessage.value = '';

    try {
      const data = await get<IFindSrfConsultantPageAppData>({
        pageId: props.pageId,
        locale: props.locale,
        page: currentPage.value,
        q: committedSearch.value || undefined,
        types: selectedConsultantTypes().join(',') || undefined,
        sort: sortKey.value ? `${sortKey.value}-${sortDirection.value}` : undefined,
        consultant: fragmentOnlyConsultantId.value ?? undefined,
      });

      if (requestId !== latestDataRequestId) {
        return;
      }

      appData.value = data;
      currentPage.value = data.currentPage;
      applyExpandedConsultantFromHash();
      updateUrl();
    } catch (error) {
      if (requestId === latestDataRequestId) {
        errorMessage.value = error instanceof Error ? error.message : '';
      }
    }
  }

  function selectedConsultantTypes() {
    return [
      { value: 'salary', selected: onlyAuthorizedSalaryConsultants.value },
      { value: 'accounting', selected: onlyAuthorizedAccountingConsultants.value },
      { value: 'business-advisor', selected: onlyCertifiedBusinessAdvisors.value },
      { value: 'agency', selected: onlyAuthorizedAgencies.value },
    ]
      .filter((type) => type.selected)
      .map((type) => type.value);
  }

  function handlePopState() {
    applySearchStateFromUrl();
    void loadAppData();
  }

  function handleHashChange() {
    const fragment = decodeURIComponent(window.location.hash.substring(1));
    const isFragmentOnly = window.location.search === '' && fragment.startsWith('consultant-');

    if (isFragmentOnly && fragment !== fragmentOnlyConsultantId.value) {
      fragmentOnlyConsultantId.value = fragment;
      currentPage.value = 1;
      void loadAppData();
      return;
    }

    applyExpandedConsultantFromHash();
  }

  function applySearchStateFromUrl() {
    isUpdatingSearchState = true;
    const parameters = new URLSearchParams(window.location.search);
    const types = parameters.getAll(typeParameter);
    const sort = parameters.get(sortParameter);
    const sortKeys: SortKey[] = ['name', 'city', 'company', 'authorization'];
    const sortDirections: SortDirection[] = ['ascending', 'descending'];
    const key = sortKeys.find((key) => sortDirections.some((direction) => sort === `${key}-${direction}`));

    sortKey.value = key ?? null;
    sortDirection.value = key && sort === `${key}-descending` ? 'descending' : 'ascending';

    draftSearch.value = (parameters.get(searchParameter) ?? '').trim();
    committedSearch.value = draftSearch.value;
    onlyAuthorizedSalaryConsultants.value = types.includes('salary');
    onlyAuthorizedAccountingConsultants.value = types.includes('accounting');
    onlyCertifiedBusinessAdvisors.value = types.includes('business-advisor');
    onlyAuthorizedAgencies.value = types.includes('agency');
    resetResultView();
    const page = Number.parseInt(parameters.get(pageParameter) ?? '', 10);
    currentPage.value = Number.isFinite(page) && page > 0 ? page : 1;
    const fragment = decodeURIComponent(window.location.hash.substring(1));
    fragmentOnlyConsultantId.value = window.location.search === '' && fragment.startsWith('consultant-')
      ? fragment
      : null;
    isUpdatingSearchState = false;
  }

  function updateUrl(pushState = false) {
    const url = new URL(window.location.href);

    const sort = sortKey.value ? `${sortKey.value}-${sortDirection.value}` : '';

    setUrlParameter(url.searchParams, sortParameter, sort);
    setUrlParameter(url.searchParams, searchParameter, committedSearch.value);
    setUrlParameter(
      url.searchParams,
      pageParameter,
      committedSearch.value || hasSelectedConsultantFilters.value ? String(currentPage.value) : '',
    );
    url.searchParams.delete(typeParameter);

    selectedConsultantTypes().forEach((type) => {
      url.searchParams.append(typeParameter, type);
    });

    const expandedConsultant = appData.value?.consultants.find((consultant) => consultant.id === expandedConsultantId.value);
    const expandedConsultantFragment = expandedConsultant ? consultantFragment(expandedConsultant) : '';

    if (expandedConsultantFragment) {
      url.hash = expandedConsultantFragment;
    } else if (appData.value && url.hash.startsWith('#consultant-')) {
      url.hash = '';
    }
    fragmentOnlyConsultantId.value = url.search === '' && url.hash.startsWith('#consultant-')
      ? decodeURIComponent(url.hash.substring(1))
      : null;

    window.history[pushState ? 'pushState' : 'replaceState']({}, '', url.toString());
  }

  function setUrlParameter(parameters: URLSearchParams, name: string, value: string) {
    if (value) {
      parameters.set(name, value);
    } else {
      parameters.delete(name);
    }
  }

  function sortBy(key: SortKey) {
    if (sortKey.value === key) {
      sortDirection.value = sortDirection.value === 'ascending' ? 'descending' : 'ascending';
    } else {
      sortKey.value = key;
      sortDirection.value = 'ascending';
    }

    resetResultView();
    updateUrl();
    void loadAppData();
  }

  function sortLabel(label: string, key: SortKey) {
    const direction = sortKey.value === key && sortDirection.value === 'ascending'
      ? translations.value.sortDescending
      : translations.value.sortAscending;

    return `${label}: ${direction}`;
  }

  function sortIconClass(key: SortKey) {
    if (sortKey.value !== key) {
      return '';
    }

    return sortDirection.value === 'ascending'
      ? 'find-srf-consultant-app__sort-icon--ascending'
      : 'find-srf-consultant-app__sort-icon--descending';
  }

  function enterDetails(element: Element, done: () => void) {
    animateDetails(element as HTMLElement, done, true);
  }

  function leaveDetails(element: Element, done: () => void) {
    animateDetails(element as HTMLElement, done, false);
  }

  function cancelDetailsAnimation(element: Element) {
    const animation = detailAnimations.get(element as HTMLElement);

    if (animation) {
      animation.commitStyles();
      animation.cancel();
      detailAnimations.delete(element as HTMLElement);
    }
  }

  function animateDetails(element: HTMLElement, done: () => void, expanding: boolean) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      clearDetailsAnimationStyles(element);
      done();
      return;
    }

    const currentStyle = getComputedStyle(element);

    if (currentStyle.display === 'none') {
      clearDetailsAnimationStyles(element);
      done();
      return;
    }

    const currentHeight = currentStyle.height;
    const currentOpacity = currentStyle.opacity;
    const currentMargin = currentStyle.marginTop;
    const interrupted = Boolean(element.style.height);

    clearDetailsAnimationStyles(element);
    const targetStyle = getComputedStyle(element);
    const expandedHeight = targetStyle.height;
    const expandedMargin = targetStyle.marginTop;
    const animation = element.animate(
      [
        {
          height: expanding && !interrupted ? '0px' : currentHeight,
          opacity: expanding && !interrupted ? 0 : currentOpacity,
          marginTop: expanding && !interrupted ? '0px' : currentMargin,
          overflow: 'hidden',
        },
        {
          height: expanding ? expandedHeight : '0px',
          opacity: expanding ? 1 : 0,
          marginTop: expanding ? expandedMargin : '0px',
          overflow: 'hidden',
        },
      ],
      { duration: 250, easing: 'ease-in-out', fill: 'both' },
    );

    detailAnimations.set(element, animation);
    animation.onfinish = () => {
      detailAnimations.delete(element);
      done();
      animation.cancel();
      clearDetailsAnimationStyles(element);
    };
  }

  function clearDetailsAnimationStyles(element: HTMLElement) {
    ['height', 'opacity', 'margin-top', 'overflow'].forEach((property) => element.style.removeProperty(property));
  }

  function toggleConsultant(consultantId: string) {
    expandedConsultantId.value = expandedConsultantId.value === consultantId ? null : consultantId;
    updateUrl();
  }

  function toggleConsultantFromRow(event: MouseEvent, consultantId: string) {
    if ((event.target as HTMLElement).closest('a, button')) {
      return;
    }

    toggleConsultant(consultantId);
  }

  function hasExpandableContactDetails(consultant: IFindSrfConsultant) {
    return Boolean(
      consultant.companyWebsite
      || consultant.hasEmail
      || consultant.hasPhone
      || consultant.linkedInUrl,
    );
  }

  function applyExpandedConsultantFromHash() {
    const fragment = decodeURIComponent(window.location.hash.substring(1));

    // Keep the fragment while the consultant data is still loading.
    if (!appData.value) {
      return;
    }

    const matchingConsultants = appData.value.consultants
      .filter((consultant) => consultantFragment(consultant) === fragment);
    const consultant = matchingConsultants.length === 1 ? matchingConsultants[0] : null;
    fragmentOnlyConsultantId.value = window.location.search === '' && consultant ? fragment : null;
    expandedConsultantId.value = consultant?.id ?? null;

    if (consultant) {
      nextTick(() => document.getElementById(fragment)?.scrollIntoView());
    }
  }

  function toggleLabel(consultant: IFindSrfConsultant) {
    const action = expandedConsultantId.value === consultant.id
      ? translations.value.collapseConsultant
      : translations.value.expandConsultant;

    return `${action} ${consultant.name}`;
  }

  function consultantFragment(consultant: IFindSrfConsultant) {
    return `consultant-${consultant.name}`
      .trim()
      .replace(/\s+/g, '-')
      .toLocaleLowerCase(props.locale);
  }

  function expandPagination(firstHiddenPage: number) {
    pageToFocus = firstHiddenPage;
    isPaginationExpanded.value = true;
  }

  function focusExpandedPage(element: unknown, pageNumber: number) {
    if (pageNumber === pageToFocus && element instanceof HTMLAnchorElement) {
      element.focus();
      pageToFocus = null;
    }
  }

  function pageUrl(pageNumber: number) {
    const url = new URL(window.location.href);

    url.searchParams.set(pageParameter, String(pageNumber));
    return url.toString();
  }

  function goToPage(pageNumber: number) {
    if (pageNumber < 1 || pageNumber > totalPages.value) {
      return;
    }

    currentPage.value = pageNumber;
    isPaginationExpanded.value = false;
    expandedConsultantId.value = null;
    updateUrl(true);
    void loadAppData();
  }

  function authorizationSummary(consultant: IFindSrfConsultant) {
    return (consultant.authorizations ?? [])
      .map((authorization) => abbreviatedAuthorizationLabel(authorization.label))
      .join(', ');
  }

  // This function takes a label string and abbreviates the first word to its first three characters followed by a period.
  // Ex: "Auktoriserad redovisningskonsult" becomes "Auk. redovisningskonsult"
  function abbreviatedAuthorizationLabel(label: string) {
    const [firstWord, ...remainingWords] = label.trim().split(/\s+/);

    return firstWord
      ? [`${firstWord.slice(0, 3)}.`, ...remainingWords].join(' ')
      : label;
  }

  function websiteLabel(url: string) {
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  function formatTranslation(template: string, ...values: Array<string | number>) {
    return values.reduce<string>(
      (formatted, value, index) => formatted.replace(`{${index}}`, String(value)),
      template,
    );
  }

  function searchWords(search: string) {
    return search
      .replace(/-/g, ' ')
      .split(/[\s,]+/)
      .map(normalizeSearchValue)
      .filter(Boolean);
  }

  function currentSearchWord(search: string) {
    return searchWords(search).at(-1) ?? '';
  }

  function replaceCurrentSearchWord(search: string, value: string) {
    return search.replace(/[^\s,]*$/, value);
  }

  function normalizeSearchValue(value: string) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase(props.locale);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingSpinner, { label: loadingLabel.value }, null, 8 /* PROPS */, ["label"]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(loadingLabel.value), 1 /* TEXT */)
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1 /* TEXT */))
        : (appData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("form", {
                class: "find-srf-consultant-app__filters",
                onSubmit: _withModifiers(applySearch, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      id: "consultant-search",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftSearch).value = $event)),
                      class: "find-srf-consultant-app__search-field input-text__input input-text__input--search",
                      type: "search",
                      role: "combobox",
                      autocomplete: "off",
                      "aria-autocomplete": "list",
                      "aria-controls": isSuggestionListOpen.value && searchSuggestions.value.length ? 'consultant-search-suggestions' : undefined,
                      "aria-activedescendant": activeSuggestionIndex.value >= 0 ? `consultant-search-suggestion-${activeSuggestionIndex.value}` : undefined,
                      "aria-expanded": isSuggestionListOpen.value && searchSuggestions.value.length > 0,
                      placeholder: translations.value.searchPlaceholder,
                      "aria-label": translations.value.searchPlaceholder,
                      onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSuggestionListOpen.value = true)),
                      onInput: handleSuggestionInput,
                      onSearch: applySearchFromInput,
                      onBlur: closeSuggestions,
                      onKeydown: [
                        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (moveSuggestion(1)), ["prevent"]), ["down"])),
                        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (moveSuggestion(-1)), ["prevent"]), ["up"])),
                        _withKeys(selectActiveSuggestion, ["enter"])
                      ]
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
                      [_vModelText, draftSearch.value]
                    ]),
                    (searchSuggestions.value.length && isSuggestionListOpen.value)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSuggestions.value, (suggestion, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              id: `consultant-search-suggestion-${index}`,
                              key: `${suggestion.type}-${suggestion.value}`,
                              class: _normalizeClass(["find-srf-consultant-app__suggestion", { 'find-srf-consultant-app__suggestion--active': activeSuggestionIndex.value === index }]),
                              role: "option",
                              "aria-selected": activeSuggestionIndex.value === index,
                              onMousedown: _withModifiers(($event: any) => (selectSuggestion(suggestion.value)), ["prevent"])
                            }, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(suggestion.type), 1 /* TEXT */),
                              _createTextVNode(" " + _toDisplayString(suggestion.value), 1 /* TEXT */)
                            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_9))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("button", _hoisted_11, _toDisplayString(translations.value.searchConsultant), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("fieldset", _hoisted_13, [
                    _createElementVNode("legend", _hoisted_14, _toDisplayString(translations.value.showOnly), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        id: "authorized-salary-consultants",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((onlyAuthorizedSalaryConsultants).value = $event)),
                        class: "checkbox__input",
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, onlyAuthorizedSalaryConsultants.value]
                      ]),
                      _createElementVNode("label", _hoisted_16, _toDisplayString(translations.value.authorizedSalaryConsultantFilter), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        id: "authorized-accounting-consultants",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((onlyAuthorizedAccountingConsultants).value = $event)),
                        class: "checkbox__input",
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, onlyAuthorizedAccountingConsultants.value]
                      ]),
                      _createElementVNode("label", _hoisted_18, _toDisplayString(translations.value.authorizedAccountingConsultantFilter), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        id: "certified-business-advisors",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((onlyCertifiedBusinessAdvisors).value = $event)),
                        class: "checkbox__input",
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, onlyCertifiedBusinessAdvisors.value]
                      ]),
                      _createElementVNode("label", _hoisted_20, _toDisplayString(translations.value.certifiedBusinessAdvisorFilter), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        id: "authorized-agencies",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((onlyAuthorizedAgencies).value = $event)),
                        class: "checkbox__input",
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, onlyAuthorizedAgencies.value]
                      ]),
                      _createElementVNode("label", _hoisted_22, _toDisplayString(translations.value.authorizedAgencyFilter), 1 /* TEXT */)
                    ])
                  ]),
                  (hasActiveFilters.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "find-srf-consultant-app__clear-button link link--with-icon",
                        type: "button",
                        onClick: clearFilters
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", {
                          class: "find-srf-consultant-app__clear-button-icon icon icon--close",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(translations.value.clearFilters), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 32 /* NEED_HYDRATION */),
              _createElementVNode("section", {
                class: "find-srf-consultant-app__results",
                "aria-labelledby": hasAppliedSearchOrFilter.value ? 'consultant-results-heading' : undefined
              }, [
                (hasAppliedSearchOrFilter.value && appData.value.consultants.length)
                  ? (_openBlock(), _createElementBlock("header", _hoisted_24, [
                      _createElementVNode("h2", _hoisted_25, _toDisplayString(translations.value.searchResults), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(resultsSummary.value), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(translations.value.sortBy), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("select", {
                          id: "consultant-sort",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedSort).value = $event)),
                          class: "dropdown__select"
                        }, [
                          (!selectedSort.value)
                            ? (_openBlock(), _createElementBlock("option", _hoisted_29, _toDisplayString(translations.value.sortBy), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appData.value.sortOptions, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: `${option.key}-${option.direction}`,
                              value: `${option.key}-${option.direction}`
                            }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_30))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, selectedSort.value]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (hasAppliedSearchOrFilter.value && appData.value.consultants.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: column.key,
                            class: _normalizeClass(["find-srf-consultant-app__column", `find-srf-consultant-app__column--${column.key}`])
                          }, [
                            _createElementVNode("button", {
                              class: "find-srf-consultant-app__sort-button",
                              type: "button",
                              "aria-label": sortLabel(column.label, column.key),
                              onClick: ($event: any) => (sortBy(column.key))
                            }, [
                              _createTextVNode(_toDisplayString(column.label) + " ", 1 /* TEXT */),
                              _createElementVNode("span", {
                                class: _normalizeClass(["find-srf-consultant-app__sort-icon icon icon--sort", sortIconClass(column.key)]),
                                "aria-hidden": "true"
                              }, null, 2 /* CLASS */)
                            ], 8 /* PROPS */, _hoisted_33),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(column.key === 'name' ? mobileColumnLabel.value : column.label), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appData.value.consultants, (consultant) => {
                          return (_openBlock(), _createElementBlock("div", {
                            id: consultantFragment(consultant),
                            key: consultant.id,
                            class: _normalizeClass(["find-srf-consultant-app__row", {
              'find-srf-consultant-app__row--expanded': expandedConsultantId.value === consultant.id,
              'find-srf-consultant-app__row--non-expandable-desktop': consultant.authorizations?.length === 1 && !hasExpandableContactDetails(consultant),
            }]),
                            onClick: ($event: any) => (toggleConsultantFromRow($event, consultant.id))
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createTextVNode(_toDisplayString(consultant.name), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_39, _toDisplayString(consultant.city ? `, ${consultant.city}` : ''), 1 /* TEXT */)
                              ]),
                              _createVNode(_Transition, {
                                css: false,
                                onEnter: enterDetails,
                                onLeave: leaveDetails,
                                onEnterCancelled: cancelDetailsAnimation,
                                onLeaveCancelled: cancelDetailsAnimation,
                                persisted: ""
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("div", {
                                    id: `consultant-profile-${consultant.id}`,
                                    class: "find-srf-consultant-app__contact find-srf-consultant-app__contact--profile"
                                  }, [
                                    (consultant.linkedInUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: consultant.linkedInUrl,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }, _toDisplayString(translations.value.toLinkedIn), 9 /* TEXT, PROPS */, _hoisted_41))
                                      : _createCommentVNode("v-if", true)
                                  ], 8 /* PROPS */, _hoisted_40), [
                                    [_vShow, expandedConsultantId.value === consultant.id]
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              (consultant.city)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(consultant.city), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createVNode(_Transition, {
                                css: false,
                                onEnter: enterDetails,
                                onLeave: leaveDetails,
                                onEnterCancelled: cancelDetailsAnimation,
                                onLeaveCancelled: cancelDetailsAnimation,
                                persisted: ""
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("div", {
                                    id: `consultant-personal-${consultant.id}`,
                                    class: "find-srf-consultant-app__contact find-srf-consultant-app__contact--personal"
                                  }, [
                                    (consultant.hasEmail)
                                      ? (_openBlock(), _createBlock(ContactReveal, {
                                          key: 0,
                                          "contact-id": consultant.id,
                                          "contact-name": consultant.name,
                                          "contact-type": "email",
                                          translations: translations.value
                                        }, null, 8 /* PROPS */, ["contact-id", "contact-name", "translations"]))
                                      : _createCommentVNode("v-if", true),
                                    (consultant.hasPhone)
                                      ? (_openBlock(), _createBlock(ContactReveal, {
                                          key: 1,
                                          "contact-id": consultant.id,
                                          "contact-name": consultant.name,
                                          "contact-type": "phone",
                                          translations: translations.value
                                        }, null, 8 /* PROPS */, ["contact-id", "contact-name", "translations"]))
                                      : _createCommentVNode("v-if", true)
                                  ], 8 /* PROPS */, _hoisted_44), [
                                    [_vShow, expandedConsultantId.value === consultant.id]
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createTextVNode(_toDisplayString(consultant.company), 1 /* TEXT */),
                                (expandedConsultantId.value !== consultant.id && consultant.authorizations?.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, ", " + _toDisplayString(authorizationSummary(consultant)), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createVNode(_Transition, {
                                css: false,
                                onEnter: enterDetails,
                                onLeave: leaveDetails,
                                onEnterCancelled: cancelDetailsAnimation,
                                onLeaveCancelled: cancelDetailsAnimation,
                                persisted: ""
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("div", {
                                    id: `consultant-company-${consultant.id}`,
                                    class: "find-srf-consultant-app__contact find-srf-consultant-app__contact--company"
                                  }, [
                                    (consultant.companyWebsite)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: consultant.companyWebsite,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }, _toDisplayString(websiteLabel(consultant.companyWebsite)), 9 /* TEXT, PROPS */, _hoisted_49))
                                      : _createCommentVNode("v-if", true)
                                  ], 8 /* PROPS */, _hoisted_48), [
                                    [_vShow, expandedConsultantId.value === consultant.id]
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _createVNode(_Transition, {
                              css: false,
                              onEnter: enterDetails,
                              onLeave: leaveDetails,
                              onEnterCancelled: cancelDetailsAnimation,
                              onLeaveCancelled: cancelDetailsAnimation
                            }, {
                              default: _withCtx(() => [
                                (expandedConsultantId.value !== consultant.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (consultant.authorizations?.length)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[12] || (_cache[12] = _createElementVNode("span", {
                                              class: "find-srf-consultant-app__check-icon icon icon--check",
                                              "aria-hidden": "true"
                                            }, null, -1 /* CACHED */)),
                                            _createElementVNode("span", _hoisted_51, _toDisplayString(authorizationSummary(consultant)), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_52, "–"))
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createElementVNode("button", {
                              class: "find-srf-consultant-app__toggle-button",
                              type: "button",
                              "aria-expanded": expandedConsultantId.value === consultant.id,
                              "aria-controls": `consultant-details-${consultant.id} consultant-profile-${consultant.id} consultant-personal-${consultant.id} consultant-company-${consultant.id}`,
                              "aria-label": toggleLabel(consultant),
                              onClick: ($event: any) => (toggleConsultant(consultant.id))
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["find-srf-consultant-app__toggle-icon icon", expandedConsultantId.value === consultant.id ? 'icon--chevron-up' : 'icon--chevron-down']),
                                "aria-hidden": "true"
                              }, null, 2 /* CLASS */)
                            ], 8 /* PROPS */, _hoisted_53),
                            _createVNode(_Transition, {
                              css: false,
                              onEnter: enterDetails,
                              onLeave: leaveDetails,
                              onEnterCancelled: cancelDetailsAnimation,
                              onLeaveCancelled: cancelDetailsAnimation,
                              persisted: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("ul", {
                                  id: `consultant-details-${consultant.id}`,
                                  class: "find-srf-consultant-app__authorizations"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consultant.authorizations ?? [], (authorization) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: authorization.id
                                    }, [
                                      _cache[13] || (_cache[13] = _createElementVNode("span", {
                                        class: "find-srf-consultant-app__check-icon icon icon--check",
                                        "aria-hidden": "true"
                                      }, null, -1 /* CACHED */)),
                                      _createTextVNode(" " + _toDisplayString(authorization.label), 1 /* TEXT */)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_54), [
                                  [_vShow, expandedConsultantId.value === consultant.id]
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ], 10 /* CLASS, PROPS */, _hoisted_36))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : (isSearchTooShort.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(translations.value.minimumSearchLength), 1 /* TEXT */))
                    : (hasAppliedSearchOrFilter.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(translations.value.noResults), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(translations.value.initialSearch), 1 /* TEXT */)),
                (hasAppliedSearchOrFilter.value && totalPages.value > 1)
                  ? (_openBlock(), _createElementBlock("nav", {
                      key: 5,
                      "aria-label": translations.value.page
                    }, [
                      _createElementVNode("ul", _hoisted_59, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["pagination__item pagination__item--control pagination__item--previous", { 'pagination__item--disabled': currentPage.value === 1 }])
                        }, [
                          (currentPage.value === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, [...(_cache[14] || (_cache[14] = [
                                _createElementVNode("span", {
                                  class: "pagination__icon icon icon--chevron-left",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)
                              ]))]))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "pagination__link",
                                href: pageUrl(currentPage.value - 1),
                                "aria-label": translations.value.previousPage,
                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (goToPage(currentPage.value - 1)), ["prevent"]))
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("span", {
                                  class: "pagination__icon icon icon--chevron-left",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_61))
                        ], 2 /* CLASS */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageNumbers.value, (pageNumber) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: typeof pageNumber === 'number' ? pageNumber : pageNumber.key,
                            class: _normalizeClass(["pagination__item pagination__item--number", { 'pagination__item--active': currentPage.value === pageNumber }])
                          }, [
                            (typeof pageNumber !== 'number')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "pagination__link",
                                  type: "button",
                                  "aria-label": translations.value.showAllPages,
                                  onClick: ($event: any) => (expandPagination(pageNumber.firstHiddenPage))
                                }, [...(_cache[16] || (_cache[16] = [
                                  _createElementVNode("span", { "aria-hidden": "true" }, "…", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_62))
                              : (currentPage.value === pageNumber)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(pageNumber), 1 /* TEXT */))
                                : (typeof pageNumber === 'number')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      class: "pagination__link",
                                      href: pageUrl(pageNumber),
                                      ref_for: true,
                                      ref: (element) => focusExpandedPage(element, pageNumber),
                                      "aria-label": `${translations.value.page} ${pageNumber}`,
                                      onClick: _withModifiers(($event: any) => (goToPage(pageNumber)), ["prevent"])
                                    }, _toDisplayString(pageNumber), 9 /* TEXT, PROPS */, _hoisted_64))
                                  : _createCommentVNode("v-if", true)
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["pagination__item pagination__item--control pagination__item--next", { 'pagination__item--disabled': currentPage.value === totalPages.value }])
                        }, [
                          (currentPage.value === totalPages.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("span", {
                                  class: "pagination__icon icon icon--chevron-right",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)
                              ]))]))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "pagination__link",
                                href: pageUrl(currentPage.value + 1),
                                "aria-label": translations.value.nextPage,
                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (goToPage(currentPage.value + 1)), ["prevent"]))
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("span", {
                                  class: "pagination__icon icon icon--chevron-right",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_66))
                        ], 2 /* CLASS */)
                      ])
                    ], 8 /* PROPS */, _hoisted_58))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_23)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
  ]))
}
}

})